﻿import "ol/ol.css";
import "ol-ext/dist/ol-ext.css";
import ProjectionHandler from './handlers/ProjectionHandler';
import { addOption, getResolutionForScale, getScaleForResolution } from './utils/utils';
import View from 'ol/View';
import { getCenter as getExtentCenter } from 'ol/extent';
import Map from 'ol/Map';
import LayerHandler from './handlers/LayerHandler';
import SelectionHandler from './handlers/SelectionHandler';
import GeolocationHandler from './handlers/GeolocationHandler';
import GeneralActionHandler from '../ui/GeneralActionHandler';
import FeatureActionHandler from '../ui/FeatureActionHandler';
import * as eventTypes from './utils/eventTypes';
import * as defaults from './utils/defaults';
import ResourcesHandler from './handlers/ResourcesHandler';
import GeneralSettingsHandler from './handlers/GeneralSettingsHandler';
import GeneralActionSettingsHandler from './handlers/GeneralActionSettingsHandler';
import LayerSettingsHandler from './handlers/LayerSettingsHandler';
import GisSettingsHandler from './handlers/GisSettingsHandler';
import TemporaryEditHandler from './handlers/TemporaryEditHandler';
import { transformExtent, transform, getPointResolution } from 'ol/proj';
import FeatureHandler from "./handlers/FeatureHandler";
import { bbox as bboxStrategy, all as allStrategy } from 'ol/loadingstrategy';
import TileQueue from 'ol/TileQueue';
import * as layerTypes from './utils/layerTypes';
import * as geomTypes from './utils/geomTypes';
import { createOlStyleFunction } from './utils/style/canvas/OlStyler';
import * as formats from './utils/formats';
import WKT from 'ol/format/WKT';
import * as styleTypes from './utils/style/styleTypes';
import { captureMapViewPng } from './utils/mapCapture';
import { fitExtent, fitFeatures } from './utils/fitUtils';
export default class MapControl {
    constructor(mapId, container, rootURL, classId) { 
        this.mapId = mapId;
        this.container = container;
        this.rootURL = rootURL;
        this.resourcesHandler = null;
        this.generalSettingsHandler = null;
        this.layerSettingsHandler = null;
        this.generalActionSettingsHandler = null;
        this.gisSettingsHandler = null;
        this.featureHandler = null;
        this.projectionHandler = new ProjectionHandler(rootURL);
        this.generalActionHandler = new GeneralActionHandler();
        this.featureActionHandler = null;
        this.gisSettingsHandler = null;
        this.map = null;
        this.layerHandler = null;
        this.selectionHandler = null;
        this.temporaryEditHandler = null;
        this.classId = classId != null ? classId : this.mapId;
        this.mapElementId = 'xpmap-' + this.mapId + '-' + this.classId;
        this.loaded = false;
        this._loadCommands();
        this._renderProfiler = null;
        this._loadProfiler = null;
        this._clearEvents();
    }

    getLayerHandler() {
        return this.layerHandler;
    }

    getLegendHandler() {
        return this.generalActionHandler.generalActionControls.legendControl;
    }

    _loadCommands() {
        let commandsUrl = this.rootURL + 'XpCommand/GetXpCommandsRuntime?ownerType=Map&id=' + this.mapId;
        return new Promise((resolve, reject) => {
            if (this.isFilter || this.isPreview) {
                resolve();
            } else {
                $.ajax({
                    type: "GET",
                    url: commandsUrl,
                    contentType: "application/json; charset=utf-8",
                    async: true,
                    success: (result) => {
                        this.commands = result;
                        resolve();
                    },
                    error: (e) => {
                        toastr.error(e.responseText, '@resources["GetCommandsError"]');
                        resolve();
                    }
                });
            }
        });
    }
    executeCommandById(id, params) {
        let foundCommands = this.commands.filter((row) => { return row.Id == id });

        if (foundCommands.length > 0) {
            return this._executeCommand(foundCommands[0], params);
        } else {
            return new Promise((resolve, reject) => { return reject('Command does not exist!'); });
        }
    }

    executeCommandByName(name, params) {
        let foundCommands = this.commands.filter((row) => { return row.Name == name });

        if (foundCommands.length > 0) {
            if (foundCommands.length > 0) {
                return this._executeCommand(foundCommands[0], params);
            } else {
                return new Promise((resolve, reject) => { return reject('Command does not exist!'); });
            }
        } else {
            return new Promise((resolve, reject) => { return reject('Command does not exist!'); });
        }
    }
    isClientCommand(id) {
        let foundCommands = this.commands.filter((row) => { return row.Id == id });

        if (foundCommands.length > 0) {
            return foundCommands[0].Type == 'CLIENT';
        }

        return false;
    }

    _executeCommand(command, params) {
        if (command.Type == 'CLIENT') {
            return new Promise((resolve, reject) => {
                try {
                    let result = window['xp_command_' + command.Id](params);

                    resolve(result);
                } catch (err) {
                    reject(err);
                }
            });
        } else if (command.Type == 'SERVER_WITH_RESULT' || command.Type == 'C_SHARP_WITH_RESULT') {
            return new Promise((resolve, reject) => {
                try {
                    let postData = {
                        id: command.Id,
                        filters: this._getCommandFilters(command),
                        params: {}
                    };

                    if (params != null) {
                        postData.params = params;
                    }

                    let commandUrl = this.rootURL + 'XpCommand/ExecuteCommandWithResult';

                    $.ajax({
                        type: "POST",
                        url: commandUrl,
                        async: true,
                        data: JSON.stringify(postData),
                        contentType: "application/json; charset=utf-8",
                        success: (result) => {
                            if (result != null) {
                                if (result.Error != null) {
                                    reject(result.Error);
                                }
                                else {
                                    var resp = JSON.parse(result);

                                    if (resp.length == 0) {
                                        resolve(null);
                                    } else if (resp.length == 1) {
                                        resolve(resp[0]);
                                    } else {
                                        resolve(resp);
                                    }
                                }                                
                            }
                        },
                        error: (e) => {
                            reject(e)
                        }
                    });
                } catch (err) {
                    reject(err);
                }
            });
        } else if (command.Type == 'SERVER_NO_RESULT' || command.Type == 'C_SHARP_NO_RESULT' || command.Type == 'SEND_EMAIL') {
            return new Promise((resolve, reject) => {
                try {
                    let postData = {
                        id: command.Id,
                        filters: this._getCommandFilters(command),
                        params: {}
                    };

                    if (params != null) {
                        postData.params = params;
                    }

                    let commandUrl = this.rootURL + 'XpCommand/ExecuteCommandWithoutResult';

                    $.ajax({
                        type: "POST",
                        url: commandUrl,
                        async: true,
                        data: JSON.stringify(postData),
                        contentType: "application/json; charset=utf-8",
                        success: (result) => {
                            if (result != null) {
                                if (result.Error != null) {
                                    reject(result.Error);
                                }
                                else {
                                    if (result.status == true) {
                                        resolve(true);
                                    } else {
                                        resolve(false);
                                    }
                                }                                
                            } else {
                                resolve(false);
                            }
                        },
                        error: (e) => {
                            reject(e)
                        }
                    });
                } catch (err) {
                    reject(err);
                }
            });
        } else {
            return new Promise((resolve, reject) => { return reject('Command type not implemented!'); });
        }
    }

    _getCommandFilters(command) {
        if (command.IdMapLayer == null) {
            return null;
        }

        let layer = this.layerSettingsHandler.getLayerSettings(command.IdMapLayer);
        return JSON.stringify(layer?.Filters || {});
    }

    geometryToWkt(geometry, featureProjection, dataProjection) {
        if (featureProjection == null && dataProjection == null) {
            featureProjection = this.generalSettingsHandler.settings.ProjCode;
            dataProjection = this.generalSettingsHandler.settings.ProjCode;
        }

        return this.projectionHandler.geometryToWkt(geometry, featureProjection, dataProjection);
    }

    parseWktFeatures(features, geomField, idField, srid, layerId) {
        return this.layerHandler._parseWktFeatures(features, geomField, idField, srid, layerId);
    }

    getLayerSettingsByEntityId(id) {
        return this.layerSettingsHandler.getLayerSettingsByEntityId(id);
    }

    //CG: bboxWkt = poligonul bbox in EPSG:4326 (vezi NominatimSearch.bboxToWkt)
    showSearchResultBBox(bboxWkt, lat, lon, styleId, minScale) {
        const size = this.map.getSize();
        let padding = [40, 40, 40, 40];
        let extraUnits = 0;
        let pointWkt = 'POINT(' + lon + ' ' + lat + ')';
        let format = new WKT();
        let mapProjection = this.generalSettingsHandler.settings.ProjCode;
        var bboxFeature = format.readFeature(bboxWkt, {
            dataProjection: 'EPSG:4326',
            featureProjection: mapProjection
        });

        var pointFeature = format.readFeature(pointWkt, {
            dataProjection: 'EPSG:4326',
            featureProjection: mapProjection
        });

        const [cx, cy] = pointFeature.getGeometry().getCoordinates();
        let [minx, miny, maxx, maxy] = bboxFeature.getGeometry().getExtent();

        const dx = Math.max(cx - minx, maxx - cx, 1e-9) + extraUnits;
        const dy = Math.max(cy - miny, maxy - cy, 1e-9) + extraUnits;

        const availW = Math.max(1, size[0] - (padding[1] + padding[3]));
        const availH = Math.max(1, size[1] - (padding[0] + padding[2]));

        const resX = (2 * dx) / availW;
        const resY = (2 * dy) / availH;
        const targetResolution = Math.max(resX, resY);

        minScale = getScaleForResolution(targetResolution, this.generalSettingsHandler.settings.ProjCode);

        let convertedWkt = format.writeFeature(pointFeature);
        this.showSearchResult(convertedWkt, styleId, minScale);
    }

    showSearchResult(wkt, styleId, minScale) {
        if (wkt != null) {
            let layer = this.layerHandler.getLayerById(layerTypes.SEARCH)[0];

            this.layerHandler.styleHandler.loadStyle((styleId == null ? styleTypes.SYSTEM_STYLE_ALL : styleId), (styleId == null ? true : false)).then(() => {
                if (styleId == null) {
                    styleId = 'sys_' + styleTypes.SYSTEM_STYLE_ALL;
                }

                let style = this.layerHandler.styleHandler.getCombinedStyle(styleId, null, null);

                let styleGetter = createOlStyleFunction(style.style, this.map);
                let styleFunction = (feature) => {
                    return styleGetter(feature);
                }

                layer.setStyle(styleFunction);

                this.addTemporaryFeatures(layerTypes.SEARCH, [{ id: 1, geom: wkt }], formats.WKT, true, true);
            });
        } else {
            let layer = this.layerHandler.getLayerById(layerTypes.SEARCH)[0];
            layer.getSource().clear();
        }
    }

    loadExternalLayer(id) {
        this.layerSettingsHandler.loadExternalLayer(id);
    }

    removeExternalLayer(id) {
        this.layerSettingsHandler.removeExternalLayer(id);
    }

    refresh() {
        this.layerHandler.refresh();
    }

    fitMap() {
        return fitExtent(this.map.getView(), this._getMapDefaultExtent(), { duration: 1000 });
    }

    zoomIn() {
        this.map.getView().animate({
            zoom: this.map.getView().getZoom() + 1,
            duration: 100
        })
    }

    zoomOut() {
        this.map.getView().animate({
            zoom: this.map.getView().getZoom() - 1,
            duration: 100
        })
    }

    /**
     * Capteaza viewport-ul curent al hartii la o dimensiune fizica data (cm + dpi) si returneaza un PNG.
     * Metoda publica, expusa pentru terti.
     *
     * @param {{ widthCm: number, heightCm: number, dpi?: number }} options - latime/inaltime in cm si dpi (default 150)
     * @returns {Promise<{ canvas: HTMLCanvasElement, dataUrl: string, blob: Blob, width: number, height: number }>}
     */
    captureViewToPng(options) {
        return captureMapViewPng(this.map, options);
    }

    getEntityLayersDescriptors() {
        return this.layerHandler.getEntityLayersDescriptors();
    }

    getRenderProfilerHistory() {
        if (!this._renderProfiler || !Array.isArray(this._renderProfiler.history)) {
            return [];
        }

        return this._renderProfiler.history.slice();
    }

    clearRenderProfilerHistory() {
        if (!this._renderProfiler || !Array.isArray(this._renderProfiler.history)) {
            return;
        }

        this._renderProfiler.history.length = 0;
    }

    getLoadMetrics() {
        if (!this._loadProfiler) {
            return null;
        }

        return {
            label: this._loadProfiler.label,
            totalMs: this._loadProfiler.totalMs,
            steps: this._loadProfiler.steps.slice()
        };
    }

    showSelectedFeatures(layerId) {
        return fitFeatures(this.map.getView(), this.getAllSelectedFeatureDetails(layerId), { duration: 1000 });
    }

    getFeature(layerId, featureId) {
        try {
            var layer = this.layerHandler.getLayerById(layerId)[0];
            var feature = null;
            if (layer.getSource().strategy_ == allStrategy) {
                var idField = layer.get("idField");
                var features = layer.getSource().getFeatures();
                for (var i = 0; i < features.length && feature == null; i++) {
                    if (features[i].get(idField) == featureId) {
                        feature = features[i];
                        break;
                    }
                }

                if (feature == null) {
                    throw "No feature found";
                }
            }
            else {
                var idField = layer.get("idField");
                var features = layer.getSource().getFeatures();
                for (var i = 0; i < features.length && feature == null; i++) {
                    if (features[i].get(idField) == featureId) {
                        feature = features[i];
                        break;
                    }
                }

                if (feature == null) {
                    feature = this.selectionHandler.getSelectedFeatureDetails(layerId, featureId);
                }

                if (feature == null) {
                    throw "No feature found";
                }
            }

            return feature;
        } catch (err) {
            return null;
        }
    }

    highlightFeature(layerId, featureId) {
        let feature = this.getFeature(layerId, featureId);

        if (feature == null) {
            return null;
        }

        let oldState = feature.get('xstate');

        if (!(this.selectionHandler != null && this.selectionHandler.highlightFeatureOverlay(feature, layerId, featureId))) {
            feature.set('xstate', 1);
        }

        return oldState;
    }

    unhighlightFeature(layerId, featureId, oldState) {
        if (oldState == null) {
            oldState = 0;
        }

        // Overlay-ul se curata dupa cheia (layerId, featureId), independent de sursa.
        if (this.selectionHandler != null && this.selectionHandler.unhighlightFeatureOverlay(layerId, featureId)) {
            return;
        }

        let feature = this.getFeature(layerId, featureId);

        if (feature != null) {
            feature.set('xstate', oldState);
        }
    }

    getSelectedFeatures() {
        var response = this.selectionHandler.getSelectedFeatures();
        if (response == null || response.layerId == null) {
            return null;
        }

        var layer = this.layerSettingsHandler.getLayerSettings(response.layerId);
        var features = [];
        for (var i = 0; i < response.selectedFeatures.length; i++) {
            var featureWKT = (new WKT()).writeGeometry(response.selectedFeatures[i].getGeometry());
            var geometryName = response.selectedFeatures[0].getGeometryName();
            var feature = JSON.parse(JSON.stringify(response.selectedFeatures[0].getProperties()));
            feature[geometryName] = featureWKT;
            features.push(feature);
        }

        return {
            layerId: response.layerId,
            layerName: layer.Title,
            selectedFeatures: features
        }
    }

    /**
     * @param {number} [scale] - scara exacta ceruta; null = o decide extentul feature-ului
     * @param {number|number[]} [padding] - padding in px la fit, uniform sau [sus, dreapta, jos, stanga]
     */
    showFeature(layerId, featureId, scale, onSuccessCallback, onErrorCallback, padding) {
        try {
            if (featureId == null || featureId == '') {
                throw "Feature has no geometry";
            }
            $event.notify(eventTypes.LAYER_VISIBILITY_CHANGED, { layerId: layerId, visible: true }, this, this.classId);
            var layer = this.layerHandler.getLayerById(layerId)[0];
            var feature = null;
            if (layer.getSource().strategy_ == allStrategy) {
                var idField = layer.get("idField");
                var features = layer.getSource().getFeatures();
                for (var i = 0; i < features.length && feature == null; i++) {
                    if (features[i].get(idField) == featureId) {
                        feature = features[i];
                        break;
                    }
                }

                if (feature == null) {
                    throw "No feature found";
                }
                this.selectionHandler.select(layerId, featureId, true, false, true);
            }
            else {
                this.refreshLayer(layerId);
                this.selectionHandler.select(layerId, featureId, true, true, true);
                feature = this.selectionHandler.getSelectedFeatureDetails(layerId, featureId);

                this.selectionHandler.notifySelection(featureId, layerId, layer);

                if (feature == null) {
                    throw "No feature found";
                }
            }


            if (feature.getGeometry() == null) {
                throw "Feature has no geometry";
            }

            fitFeatures(this.map.getView(), [feature], { scale: scale, layer: layer, padding: padding, duration: 1000 });

            if (onSuccessCallback != null) {
                onSuccessCallback();
            }
        }
        catch (e) {
            if (onErrorCallback != null) {
                onErrorCallback(e);
            }
        }
    }

    centerByWkt(wkt, scale, projectionCode) {
        var format = new WKT();
        this.center(format.readFeature(wkt).getGeometry().getFlatCoordinates(), scale, projectionCode);
    }

    showFeatures(layerId, featureIds, scale, onSuccessCallback, onErrorCallback) {
        if (featureIds == null) {
            throw "No feature was requested";
        }

        if (!Array.isArray(featureIds)) {
            featureIds = [featureIds];
        }

        if (featureIds.length > 1) {
            this.selectionHandler.selectionHolder.allowMultiple = true;
        }

        try {
            $event.notify(eventTypes.LAYER_VISIBILITY_CHANGED, { layerId: layerId, visible: true }, this, this.classId);
            let layer = this.layerHandler.getLayerById(layerId)[0];
            let features = [];

            if (layer.getSource().strategy_ == allStrategy) {
                let idField = layer.get("idField");
                let all = layer.getSource().getFeatures();
                featureIds.forEach(featureId => {
                    let found = all.find(x => x.get(idField) == featureId);
                    if (found) {
                        features.push(found);
                        this.selectionHandler.select(layerId, featureId, true, false, true);
                    }
                });

                if (features.length == 0) {
                    throw "No feature found";
                }
            } else {
                this.refreshLayer(layerId);
                featureIds.forEach(featureId => {
                    this.selectionHandler.select(layerId, featureId, true, true, true);
                });

                features = this.selectionHandler.getSelectedFeaturesDetails(layerId, featureIds);
            }

            featureIds.forEach(featureId => {
                this.selectionHandler.notifySelection(featureId, layerId, layer);
            });

            fitFeatures(this.map.getView(), features, { scale: scale, layer: layer, duration: 2000 });

            if (onSuccessCallback != null) {
                onSuccessCallback();
            }
        } catch (e) {
            if (onErrorCallback != null) {
                onErrorCallback(e);
            }
        }
    }

    init() {
        return new Promise((resolve, reject) => {
            let promises = [];
            this.resourcesHandler = new ResourcesHandler(this.rootURL);
            this.generalSettingsHandler = new GeneralSettingsHandler(this.rootURL, this.mapId);
            this.generalActionSettingsHandler = new GeneralActionSettingsHandler(this.rootURL, this.mapId);
            this.layerSettingsHandler = new LayerSettingsHandler(this.rootURL, this.mapId, this.resourcesHandler, this.classId);
            this.featureHandler = new FeatureHandler(this.generalSettingsHandler, this.layerSettingsHandler, this.rootURL, this);
            this.layerSettingsHandler.featureHandler = this.featureHandler;
            this.gisSettingsHandler = new GisSettingsHandler(this.rootURL);

            this._initLoadProfiler();
            promises.push(this._profileLoadStep('resources', this.resourcesHandler.load()));
            promises.push(this._profileLoadStep('generalSettings', this.generalSettingsHandler.load()));
            promises.push(this._profileLoadStep('generalActionSettings', this.generalActionSettingsHandler.load()));
            promises.push(this._profileLoadStep('layerSettings', this.layerSettingsHandler.load()));
            promises.push(this._profileLoadStep('gisSettings', this.gisSettingsHandler.load()));
            this._showLoadingPanel();
            Promise.all(promises).then(() => {
                this._init().then(() => {
                    this._profileLoadMark('hideLoadingPanel', () => this._hideLoadingPanel());
                    this.loaded = true;

                    this._profileLoadMark('geolocationInit', () => {
                        this.geolocationHandler = new GeolocationHandler(this.layerHandler);
                        this.geolocationHandler.init();
                    });

                    this._profileLoadMark('searchLayerInit', () => {
                        this.addTemporaryVectorLayer({
                            name: layerTypes.SEARCH,
                            geometryType: geomTypes.GEOM_ALL,
                            srid: this.generalSettingsHandler.settings.ProjCode,
                            geomField: 'geom',
                            idField: 'id',
                            visible: true,
                            ignoreStyle: true,
                            addToLegend: false,
                            showLegend: false,
                            declutter: false
                        });
                    });

                    this._profileLoadMark('mapLoadedNotify', () => {
                        $event.notify(eventTypes.MAP_LOADED, null, this, this.classId);
                    });

                    this._finishLoadProfile('completed');
                    resolve();
                }).catch(err => {
                    console.error('[XPortal] Map ' + this.mapId + ' init failed', err);
                    this._finishLoadProfile('failed');
                    this._hideLoadingPanel();
                    reject(err);
                });
            }).catch(err => {
                console.error('[XPortal] Map ' + this.mapId + ' settings load failed', err);
                this._finishLoadProfile('failed');
                this._hideLoadingPanel();
                reject(err);
            });
        });
    }

    deselectAll(layerId) {
        this.selectionHandler.deselectAll(layerId);
    }

    refreshLayer(layerId, force) {
        this.layerHandler.refreshLayer(layerId, force);
    }


    getFeatureDetails(layerUid, featureId) {
        try {
            return this.selectionHandler.getSelectedFeatureDetails(layerUid, featureId);
        }
        catch (e) {
            return null;
        }
    }

    getAllSelectedFeatureDetails(layerId) {
        try {
            return this.selectionHandler.getAllSelectedFeatureDetails(layerId);
        }
        catch (e) {
            return null;
        } 
    }

    removeFeatures(features) {
        this.featureHandler.removeFeatures(features);
    }

    getAllSelectedFeatures(layerId) {
        return this.selectionHandler.getAllSelectedFeatures(layerId);
    }

    getViewExtent() {
        return this.map.getView().getViewStateAndExtent().extent;
    }

    getViewCenter() {
        return this.map.getView().getCenter();
    }

    getViewScale() {
        if (this.map) {
            let resolution = this.map.getView().getResolution();
            return getScaleForResolution(resolution, this.generalSettingsHandler.settings.ProjCode);
        }
    }

    setProjection(projectionCode) {
        this.projectionHandler.load(projectionCode).then(() => {
            this.generalSettingsHandler.setProjection(projectionCode);
            this.refreshView();
        });
    }

    getViewProjection() {
        return this.map.getView().getProjection().getCode();
    }

    reprojectExtent(extent, initialProjection, targetProjection) {
        return transformExtent(extent, initialProjection, targetProjection);
    }

    reprojectCoordinate(coordinate, initialProjection, targetProjection) {
        return transform(coordinate, initialProjection, targetProjection);
    }

    transformCoordinates(coordinates, fromProjCode, toProjCode) {

        return transform(coordinates, fromProjCode, toProjCode);
    }

    center(pointCoordinates, scale, projectionCode) {
        if (pointCoordinates == null || pointCoordinates.length != 2) {
            return;
        }

        if (projectionCode != null && projectionCode != this.map.getView().getProjection().getCode()) {
            pointCoordinates = transform(pointCoordinates, projectionCode, this.map.getView().getProjection().getCode());
        }

        var resolution = this.map.getView().get('resolution');
        if (scale != null && !isNaN(scale) && scale > 0) {
            resolution = getResolutionForScale(scale, this.map.getView().getProjection().getCode());
        }

        this.map.getView().animate({
            center: pointCoordinates,
            resolution: resolution,
            duration: 500
        });
    }

    refreshView() {
        let options = {};
        let projExtent = this.projectionHandler.getProjExtent(this.generalSettingsHandler.settings.ProjCode);

        addOption(options, 'extent', projExtent);
        //addOption(options, "minResolution", getResolutionForScale(null, this.generalSettingsHandler.settings.ProjCode));
        //addOption(options, "maxResolution", getResolutionForScale(null, this.generalSettingsHandler.settings.ProjCode));
        let oldProj = this.getViewProjection();
        let newProj = this.generalSettingsHandler.settings.ProjCode;
        let center = this.getViewCenter();
        let oldProjection = this.projectionHandler.getProj(this.getViewProjection());
        let newProjection = this.projectionHandler.getProj(this.generalSettingsHandler.settings.ProjCode);
        let newCenter = transform(center, oldProjection, newProjection);

        addOption(options, 'center', newCenter);

        let resolution = this.map.getView().getResolution();
        let oldMPU = oldProjection.getMetersPerUnit();
        let newMPU = newProjection.getMetersPerUnit();
        let oldPR = getPointResolution(oldProjection, 1 / oldMPU, center, 'm') * oldMPU;
        let newPR = getPointResolution(newProjection, 1 / newMPU, newCenter, 'm') * newMPU;
        let newResolution = (resolution * oldPR) / newPR;

        addOption(options, "resolution", newResolution);
        addOption(options, 'projection', this.projectionHandler.getProj(this.generalSettingsHandler.settings.ProjCode));
        addOption(options, "zoom", 1);

        let view = new View(
            options
        );

        view.on('change:resolution', () => {
            var scale = this.getViewScale();

            if (scale) {
                $event.notify(eventTypes.SCALE_CHANGED, {
                    scale: '1 : ' + parseInt(scale).toLocaleString()
                }, this, this.classId);
            }
        });

        this.map.setView(view);
        this.layerHandler.handleProjectionChange(oldProj, newProj);
    }

    disableViewExtentAndScale(keepExtent) {
        let options = {};
        let projExtent = this.projectionHandler.getProjExtent(this.generalSettingsHandler.settings.ProjCode);

        addOption(options, 'extent', keepExtent ? this.getViewExtent() : projExtent);
        addOption(options, "minResolution", getResolutionForScale(null, this.generalSettingsHandler.settings.ProjCode));
        addOption(options, "maxResolution", getResolutionForScale(null, this.generalSettingsHandler.settings.ProjCode));
        addOption(options, 'center', this.getViewCenter());
        addOption(options, "resolution", this.map.getView().getResolution());
        addOption(options, 'projection', this.projectionHandler.getProj(this.generalSettingsHandler.settings.ProjCode));
        addOption(options, "zoom", 1);

        let view = new View(
            options
        );

        view.on('change:resolution', () => {
            var scale = this.getViewScale();

            if (scale) {
                $event.notify(eventTypes.SCALE_CHANGED, {
                    scale: '1 : ' + parseInt(scale).toLocaleString()
                }, this, this.classId);
            }
        });

        this.map.setView(view);
    }

    resetViewExtent() {
        if (this.generalSettingsHandler.settings.ProjCode != this.getViewProjection()) {
            this.layerHandler.handleProjectionChange(this.getViewProjection(), this.generalSettingsHandler.settings.ProjCode);
        }
        this.map.setView(this._initView());
    }

    _clearEvents() {
        $event.clearReference(this.classId);
    }

    _showLoadingPanel() {
        Swal.fire({
            target: this.container,
            allowOutsideClick: false,
            willOpen: () => {
                Swal.showLoading();
                $('body').css('overflow', 'auto');
            },
            customClass: {
                container: 'position-absolute'
            }
        });
    }

    // Pereche locala pentru _showLoadingPanel: nu depinde de globalul hideLoadingPanel
    // (definit abia in _ScriptsBasePlugins, dupa bundle) si inchide imediat, fara delay-ul de 1s.
    _hideLoadingPanel() {
        Swal.close();
    }

    fitFeature(layerId, featureId) {
        return this.layerHandler.fitFeature(layerId, featureId);
    }

    fitWktGeometry(wkt, scale, featureProjection, dataProjection) {
        this.layerHandler.fitWktGeometry(wkt, scale, featureProjection, dataProjection);
    }

    clearSelection() {
        this.layerHandler.clearSelection();
    }

    fitTemporaryFeature(layerId, featureId) {
        return this.layerHandler.fitTemporaryFeature(layerId, featureId);
    }

    load(resourcesHandler, generalSettingsHandler, layerSettingsHandler, generalActionSettingsHandler, gisSettingsHandler) {
        return new Promise((resolve, reject) => {
            this.resourcesHandler = resourcesHandler;
            this.generalSettingsHandler = generalSettingsHandler;
            this.layerSettingsHandler = layerSettingsHandler;
            this.generalActionSettingsHandler = generalActionSettingsHandler;
            this.gisSettingsHandler = gisSettingsHandler;
            this._initLoadProfiler();
            showLoadingPanel();
            this._init().then(() => {
                this._profileLoadMark('hideLoadingPanel', () => hideLoadingPanel());
                this._finishLoadProfile('completed');
                resolve();
            }).catch(err => {
                console.error('[XPortal] Map ' + this.mapId + ' init failed', err);
                this._finishLoadProfile('failed');
                hideLoadingPanel();
                reject(err);
            });
        });
    }

    clearSelection() {
        this.selectionHandler.clearSelection();
    }

    addTemporaryVectorLayer(options) {
        this.clearSelection();
        return this.layerHandler.addTemporaryVectorLayer(options);
    }

    addTemporaryFeatures(layerId, features, format, clearPrevious, fit) {
        return this.layerHandler.addTemporaryFeatures(layerId, features, format, clearPrevious, fit);
    }

    removeTemporaryFeatures(layerId, features) {
        return this.layerHandler.removeTemporaryFeatures(layerId, features);
    }

    clearTemporaryFeatures(layerId) {
        return this.layerHandler.clearTemporaryFeatures(layerId);
    }

    getFeatureById(layerId, featureId) {
        return this.layerHandler.getFeatureById(layerId, featureId);
    }

    _init() {
        return new Promise((resolve, reject) => {
            this.container.append(this._getMapTemplate());
            this._loadAdditionalConfig().then(() => {
                this._registerNotificationHandlers();
                resolve();
            }).catch(reject);
        });
    }

    _loadAdditionalConfig() {
        return new Promise((resolve, reject) => {
            let promises = [];

            if (this.generalSettingsHandler.settings.ProjCode == null || this.generalSettingsHandler.settings.ProjCode.trim() == '') {
                this.generalSettingsHandler.settings.ProjCode = defaults.DEFAULT_SRID;
            }

            promises.push(this._profileLoadStep('projectionLoad', this.projectionHandler.load(this.generalSettingsHandler.settings.ProjCode)));
            Promise.all(promises).then(() => {
                this._profileLoadMark('uiHandlersInit', () => {
                    this.map = this._initMap();
                    this._initRenderProfiler();
                    this.selectionHandler = new SelectionHandler(this.map, this.layerSettingsHandler, this.generalSettingsHandler, this.mapId, this.classId, this.featureHandler, this.resourcesHandler);
                    this.selectionHandler.init();

                    this.layerHandler = new LayerHandler(this.mapId, this.map, this.layerSettingsHandler, this.projectionHandler, this.generalSettingsHandler, this.gisSettingsHandler, this.selectionHandler, this.rootURL, this.classId, this);

                    this.generalActionHandler = new GeneralActionHandler(this.generalActionSettingsHandler, this.resourcesHandler, this.layerSettingsHandler, this.container, this.mapId, this.rootURL, this.classId, this.layerHandler.styleHandler, this);
                    this.generalActionHandler.init();

                    this.featureActionHandler = new FeatureActionHandler(this, this.classId, this.container, this.generalSettingsHandler, this.rootURL, this.resourcesHandler, this.generalActionHandler.addLayers, this.generalActionHandler.generalActionControls.editControl, this.generalActionHandler.multipleAddLayers, this.generalActionHandler);
                    this.featureActionHandler.init();
                });

                this._profileLoadStep('layersInit', this.layerHandler.init()).then(() => {
                    // TO DO: de venit cu o idee mai buna
                    //this._animate(this.map);
                    resolve();
                }).catch(reject);

                this.temporaryEditHandler = new TemporaryEditHandler(this.mapId, this.map, this.layerHandler, this.selectionHandler, this.classId);
            }).catch(reject);
        });
    }

    _animate(map) {
        map.render();
        requestAnimationFrame(() => this._animate(map));
    }

    _isTruthyFlag(value) {
        if (value == null) {
            return false;
        }

        const parsed = String(value).trim().toLowerCase();
        return parsed === '1' || parsed === 'true' || parsed === 'yes' || parsed === 'on';
    }

    _isRenderProfilerEnabled() {
        try {
            const storedValue = localStorage.getItem('xportal.renderProfiler');
            if (storedValue != null) {
                return this._isTruthyFlag(storedValue);
            }
        } catch (e) {
        }

        try {
            const search = typeof window !== 'undefined' && window.location ? window.location.search : null;
            if (search && search.length > 1) {
                const queryValue = new URLSearchParams(search).get('xportalRenderProfiler');
                if (queryValue != null) {
                    return this._isTruthyFlag(queryValue);
                }
            }
        } catch (e) {
        }

        return false;
    }

    _isLoadProfilerEnabled() {
        try {
            const storedValue = localStorage.getItem('xportal.loadProfiler');
            if (storedValue != null) {
                return this._isTruthyFlag(storedValue);
            }
        } catch (e) {
        }

        try {
            const search = typeof window !== 'undefined' && window.location ? window.location.search : null;
            if (search && search.length > 1) {
                const queryValue = new URLSearchParams(search).get('xportalLoadProfiler');
                if (queryValue != null) {
                    return this._isTruthyFlag(queryValue);
                }
            }
        } catch (e) {
        }

        return false;
    }

    // Timpii de incarcare se colecteaza mereu (cost neglijabil); console-ul se umple doar cu flagul activ.
    _initLoadProfiler() {
        this._loadProfiler = {
            t0: performance.now(),
            steps: [],
            finished: false,
            totalMs: null,
            label: null
        };
    }

    _profileLoadStep(name, promise) {
        const profiler = this._loadProfiler;
        if (!profiler || profiler.finished || promise == null || typeof promise.then !== 'function') {
            return promise;
        }

        const startMs = performance.now() - profiler.t0;
        const entry = { step: name, startMs: Math.round(startMs), durationMs: null, status: 'pending' };
        profiler.steps.push(entry);

        const complete = (status) => {
            entry.durationMs = Math.round(performance.now() - profiler.t0 - startMs);
            entry.status = status;
        };

        return promise.then(
            value => { complete('ok'); return value; },
            err => { complete('error: ' + (err && err.message ? err.message : err)); throw err; }
        );
    }

    _profileLoadMark(name, fn) {
        const profiler = this._loadProfiler;
        if (!profiler || profiler.finished) {
            return fn();
        }

        const startMs = performance.now() - profiler.t0;
        const entry = { step: name, startMs: Math.round(startMs), durationMs: null, status: 'pending' };
        profiler.steps.push(entry);

        try {
            const result = fn();
            entry.durationMs = Math.round(performance.now() - profiler.t0 - startMs);
            entry.status = 'ok';
            return result;
        } catch (err) {
            entry.durationMs = Math.round(performance.now() - profiler.t0 - startMs);
            entry.status = 'error: ' + (err && err.message ? err.message : err);
            throw err;
        }
    }

    _finishLoadProfile(label) {
        const profiler = this._loadProfiler;
        if (!profiler || profiler.finished) {
            return;
        }

        profiler.finished = true;
        profiler.label = label;
        profiler.totalMs = Math.round(performance.now() - profiler.t0);

        if (this._isLoadProfilerEnabled()) {
            console.info('[XPortal][Perf] Map ' + this.mapId + ' load ' + label + ' in ' + profiler.totalMs + ' ms. Use localStorage.removeItem("xportal.loadProfiler") to disable.');
            console.table(profiler.steps.map(s => ({
                step: s.step,
                'start (ms)': s.startMs,
                'duration (ms)': s.durationMs,
                status: s.status
            })));
        }
    }

    _initRenderProfiler() {
        if (!this.map || !this._isRenderProfilerEnabled()) {
            return;
        }

        if (this._renderProfiler && this._renderProfiler.initialized) {
            return;
        }

        this._renderProfiler = {
            initialized: true,
            nextSessionId: 1,
            activeSession: null,
            pendingFinalizeTimer: null,
            history: [],
            maxHistory: 50
        };

        this.map.on('movestart', () => this._handleRenderProfilerMoveStart());
        this.map.on('moveend', () => this._handleRenderProfilerMoveEnd());
        this.map.on('postrender', () => this._handleRenderProfilerPostRender());
        this.map.on('rendercomplete', () => this._handleRenderProfilerRenderComplete());

        console.info('[XPortal][Perf] Render profiler enabled. Use localStorage.removeItem("xportal.renderProfiler") to disable.');
    }

    _startRenderProfilerSession(reason) {
        const profiler = this._renderProfiler;
        if (!profiler || !this.map) {
            return;
        }

        if (profiler.pendingFinalizeTimer != null) {
            clearTimeout(profiler.pendingFinalizeTimer);
            profiler.pendingFinalizeTimer = null;
        }

        const view = this.map.getView();
        profiler.activeSession = {
            id: profiler.nextSessionId++,
            reason: reason || 'interaction',
            startedAt: performance.now(),
            moveEndAt: null,
            completedAt: null,
            startResolution: view ? view.getResolution() : null,
            endResolution: null,
            startCenter: view ? view.getCenter() : null,
            endCenter: null,
            frameCount: 0,
            lastFrameAt: null,
            maxFrameGapMs: 0
        };
    }

    _handleRenderProfilerMoveStart() {
        this._startRenderProfilerSession('move');
    }

    _handleRenderProfilerMoveEnd() {
        const profiler = this._renderProfiler;
        if (!profiler || !this.map) {
            return;
        }

        if (profiler.activeSession == null) {
            this._startRenderProfilerSession('move');
        }

        const session = profiler.activeSession;
        const view = this.map.getView();

        session.moveEndAt = performance.now();
        session.endResolution = view ? view.getResolution() : null;
        session.endCenter = view ? view.getCenter() : null;

        if (profiler.pendingFinalizeTimer != null) {
            clearTimeout(profiler.pendingFinalizeTimer);
        }

        profiler.pendingFinalizeTimer = setTimeout(() => {
            this._finalizeRenderProfilerSession('timeout');
        }, 500);
    }

    _handleRenderProfilerPostRender() {
        const profiler = this._renderProfiler;
        if (!profiler || profiler.activeSession == null) {
            return;
        }

        const session = profiler.activeSession;
        const now = performance.now();
        session.frameCount += 1;

        if (session.lastFrameAt != null) {
            const frameGap = now - session.lastFrameAt;
            if (frameGap > session.maxFrameGapMs) {
                session.maxFrameGapMs = frameGap;
            }
        }

        session.lastFrameAt = now;
    }

    _handleRenderProfilerRenderComplete() {
        const profiler = this._renderProfiler;
        if (!profiler || profiler.activeSession == null) {
            return;
        }

        const session = profiler.activeSession;
        if (session.moveEndAt == null) {
            return;
        }

        this._finalizeRenderProfilerSession('rendercomplete');
    }

    _toFixedNumber(value, digits) {
        if (!Number.isFinite(value)) {
            return null;
        }
        return Number(value.toFixed(digits != null ? digits : 2));
    }

    _getCenterDistance(centerA, centerB) {
        if (!centerA || !centerB || centerA.length < 2 || centerB.length < 2) {
            return null;
        }

        const dx = Number(centerB[0]) - Number(centerA[0]);
        const dy = Number(centerB[1]) - Number(centerA[1]);

        if (!Number.isFinite(dx) || !Number.isFinite(dy)) {
            return null;
        }

        return Math.sqrt(dx * dx + dy * dy);
    }

    _getLoadedVectorLayerStats() {
        if (!this.map) {
            return [];
        }

        const layers = this.map.getLayers().getArray();
        const stats = [];

        for (let i = 0; i < layers.length; i++) {
            const layer = layers[i];
            if (!layer || typeof layer.getSource !== 'function') {
                continue;
            }

            // Overlay-ul de hover tine clone ale featurilor de baza => nu le numaram de doua ori.
            if (layer.get('uid') === 'HOVER_OVERLAY') {
                continue;
            }

            let source = layer.getSource();
            if (!source) {
                continue;
            }

            let loadedFeatures = null;
            if (typeof source.getFeatures === 'function') {
                loadedFeatures = source.getFeatures().length;
            } else if (typeof source.getSource === 'function') {
                const childSource = source.getSource();
                if (childSource && typeof childSource.getFeatures === 'function') {
                    loadedFeatures = childSource.getFeatures().length;
                }
            }

            if (!Number.isFinite(loadedFeatures)) {
                continue;
            }

            stats.push({
                layerId: layer.get('uid') || layer.get('name') || ('layer-' + i),
                loadedFeatures: loadedFeatures,
                visible: typeof layer.getVisible === 'function' ? layer.getVisible() : null
            });
        }

        return stats;
    }

    _getRenderSimplificationProfileTag() {
        const defaults = {
            enabled: true,
            toleranceFactor: 2.2,
            bucketStepsPerZoom: 1,
            maxBucketsPerGeometry: 2,
            minVertexCount: 1024,
            avoidComputeWhileInteracting: true,
            reuseNearestBucketWhileInteracting: true
        };

        let configured = {};
        try {
            const raw = typeof localStorage !== 'undefined'
                ? localStorage.getItem('xportal.renderSimplification')
                : null;
            if (raw != null && String(raw).trim() !== '') {
                configured = JSON.parse(raw);
            }
        } catch (e) {
            configured = {};
        }

        const settings = { ...defaults, ...configured };
        return {
            enabled: settings.enabled === true,
            toleranceFactor: settings.toleranceFactor,
            bucketStepsPerZoom: settings.bucketStepsPerZoom,
            maxBucketsPerGeometry: settings.maxBucketsPerGeometry,
            minVertexCount: settings.minVertexCount,
            avoidComputeWhileInteracting: settings.avoidComputeWhileInteracting !== false,
            reuseNearestBucketWhileInteracting: settings.reuseNearestBucketWhileInteracting !== false
        };
    }

    _getRenderCullingProfileTag() {
        const defaults = {
            enabled: true,
            minLineLengthPx: 3.5,
            minPolygonAreaPx2: 10,
            minPolygonExtentPx: 3.75
        };

        let configured = {};
        try {
            const raw = typeof localStorage !== 'undefined'
                ? localStorage.getItem('xportal.renderCulling')
                : null;
            if (raw != null && String(raw).trim() !== '') {
                configured = JSON.parse(raw);
            }
        } catch (e) {
            configured = {};
        }

        const settings = { ...defaults, ...configured };
        return {
            enabled: settings.enabled === true,
            minLineLengthPx: settings.minLineLengthPx,
            minPolygonAreaPx2: settings.minPolygonAreaPx2,
            minPolygonExtentPx: settings.minPolygonExtentPx
        };
    }

    _finalizeRenderProfilerSession(trigger) {
        const profiler = this._renderProfiler;
        if (!profiler || profiler.activeSession == null) {
            return;
        }

        const session = profiler.activeSession;

        if (profiler.pendingFinalizeTimer != null) {
            clearTimeout(profiler.pendingFinalizeTimer);
            profiler.pendingFinalizeTimer = null;
        }

        session.completedAt = performance.now();

        const totalMs = session.completedAt - session.startedAt;
        const interactionMs = session.moveEndAt != null ? (session.moveEndAt - session.startedAt) : null;
        const settleMs = session.moveEndAt != null ? (session.completedAt - session.moveEndAt) : null;
        const centerDistance = this._getCenterDistance(session.startCenter, session.endCenter);

        let interactionType = 'pan';
        if (session.startResolution != null && session.endResolution != null && session.startResolution !== 0) {
            const resolutionRatio = session.endResolution / session.startResolution;
            if (Number.isFinite(resolutionRatio) && Math.abs(Math.log2(resolutionRatio)) > 0.001) {
                interactionType = centerDistance != null && centerDistance > 0 ? 'pan+zoom' : 'zoom';
            }
        }

        const layerStats = this._getLoadedVectorLayerStats();
        const totalLoadedFeatures = layerStats.reduce((sum, item) => sum + item.loadedFeatures, 0);
        const topLayers = layerStats
            .filter(item => item.loadedFeatures > 0)
            .sort((a, b) => b.loadedFeatures - a.loadedFeatures)
            .slice(0, 5);

        const summary = {
            sessionId: session.id,
            trigger: trigger,
            interaction: interactionType,
            totalMs: this._toFixedNumber(totalMs, 2),
            interactionMs: this._toFixedNumber(interactionMs, 2),
            settleMs: this._toFixedNumber(settleMs, 2),
            frames: session.frameCount,
            maxFrameGapMs: this._toFixedNumber(session.maxFrameGapMs, 2),
            loadedFeatures: totalLoadedFeatures,
            startResolution: this._toFixedNumber(session.startResolution, 6),
            endResolution: this._toFixedNumber(session.endResolution, 6),
            centerDelta: this._toFixedNumber(centerDistance, 3),
            renderSimplification: this._getRenderSimplificationProfileTag(),
            renderCulling: this._getRenderCullingProfileTag()
        };

        profiler.history.push(summary);
        if (profiler.history.length > profiler.maxHistory) {
            profiler.history.shift();
        }

        console.log('[XPortal][Perf] Interaction profile', summary);
        if (topLayers.length > 0) {
            console.table(topLayers);
        }

        profiler.activeSession = null;
    }

    _registerNotificationHandlers() {
        $event.register(eventTypes.LAYER_OPACITY_CHANGED, this._getLayerOpacityChangedHandler(), this, this.classId);
        $event.register(eventTypes.LAYER_VISIBILITY_CHANGED, this._getLayerVisibilityChangedHandler(), this, this.classId);
        $event.register(eventTypes.LAYER_CLASSIFICATION_VISIBILITY_CHANGED, this._getLayerClassificationVisibilityChangedHandler(), this, this.classId);
        $event.register(eventTypes.LAYER_ORDER_CHANGED, this._getLayerOrderChangedHandler(), this, this.classId);
        $event.register(eventTypes.LAYER_REMOVED, this._getLayerRemovedHandler(), this, this.classId);
    }

    _getLayerOpacityChangedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null) {
                this.layerHandler.changeLayerOpacity(data.layerId, data.opacity);
            }
        };

        return handler;
    }

    _getLayerClassificationVisibilityChangedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null) {
                this.layerHandler.changeLayerClassificationVisibility(data.layerId, data.classificationIdx, data.visible);
            }
        };

        return handler;
    }

    _getLayerVisibilityChangedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null) {
                this.layerHandler.changeLayerVisibility(data.layerId, data.visible);
            }
        };

        return handler;
    }

    _getLayerOrderChangedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null) {
                this.layerHandler.changeLayersOrder(data.layers, true);
            }
        };

        return handler;
    }

    getLayerSettings(layerId) {
        return this.layerHandler.getLayerSettings(layerId);
    }

    getLayer(layerId) {
        let layers = this.layerHandler.getLayerById(layerId);

        if (layers != null && layers.length > 0) {
            return layers[0];
        }
        return null;
    }

    getLayerStyle(layerId) {
        return this.layerHandler.getLayerStyle(layerId);
    }

    selectFeature(layerId, featureId, initialized, ignoreNotification, force) {
        this.selectionHandler.select(layerId, featureId, initialized, ignoreNotification, force);
    }

    deselectFeature(layerId, featureId) {
        this.selectionHandler.deselectFeature(layerId, featureId);
    }

    _getLayerRemovedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null) {
                this.layerHandler.removeLayers(data.ids);
            }
        };

        return handler;
    }

    _initMap() {
        let view = this._initView();
        let map = new Map({
            layers: [],
            target: document.getElementById(this.mapElementId),
            view: view
        });

        return map;
    }

    setScale(scale) {
        this.map.getView().setResolution(getResolutionForScale(scale, this.generalSettingsHandler.settings.ProjCode));
    }

    _initView() {
        let options = {};

        addOption(options, 'extent', this._getMapDefaultExtent());
        addOption(options, "minResolution",
            getResolutionForScale(this.generalSettingsHandler.settings.MinScale, this.generalSettingsHandler.settings.ProjCode));
        addOption(options, "maxResolution",
            getResolutionForScale(this.generalSettingsHandler.settings.MaxScale, this.generalSettingsHandler.settings.ProjCode));
        addOption(options, 'center', this._getMapDefaultCenterPoint());
        addOption(options, "resolution",
            getResolutionForScale(this.generalSettingsHandler.settings.DefaultScale, this.generalSettingsHandler.settings.ProjCode));
        addOption(options, 'projection', this.projectionHandler.getProj(this.generalSettingsHandler.settings.ProjCode));
        addOption(options, "zoom", 1);

        let view = new View(
            options
        );

        view.on('change:resolution', () => {
            var scale = this.getViewScale()

            if (scale) {
                $event.notify(eventTypes.SCALE_CHANGED, {
                    scale: '1 : ' + parseInt(scale).toLocaleString()
                }, this, this.classId);
            }
        });

        return view;
    }

    _getMapDefaultExtent() {
        let xMin = this.generalSettingsHandler.settings.XMin;
        let yMin = this.generalSettingsHandler.settings.YMin;
        let xMax = this.generalSettingsHandler.settings.XMax;
        let yMax = this.generalSettingsHandler.settings.YMax;

        if (xMin != null && yMin != null && xMax != null && yMax != null) {
            return [xMin, yMin, xMax, yMax];
        }

        return this.projectionHandler.getProjExtent(this.generalSettingsHandler.settings.ProjCode);
    }

    _getMapDefaultCenterPoint() {

        if (this.generalSettingsHandler.settings.DefaultCenterPointX != null && this.generalSettingsHandler.settings.DefaultCenterPointY != null) {
            return [this.generalSettingsHandler.settings.DefaultCenterPointX, this.generalSettingsHandler.settings.DefaultCenterPointY];
        }

        let extent = this._getMapDefaultExtent();
        return getExtentCenter(extent);
    }

    _getMapTemplate() {
        let div = document.createElement('div');
        div.innerHTML = `<div class="map" id=` + this.mapElementId + `>
                        </div>`;
        return div.firstChild;
    }
}
